export type BackendUserRole = 'Admin' | 'Manager' | 'Sales' | 'WhiteLabel';
export type FrontendUserRole = 'admin' | 'gerente' | 'vendedor' | 'whitelabel';

export function mapBackendRoleToFrontend(role: string): FrontendUserRole {
  const normalized = (role || '').toLowerCase();
  
  switch (normalized) {
    case 'admin':
      return 'admin';
    case 'manager':
      return 'gerente';
    case 'sales':
      return 'vendedor';
    case 'whitelabel':
      return 'whitelabel';
    default:
      return 'vendedor'; // Default fallback
  }
}

export function mapFrontendRoleToBackend(role: FrontendUserRole): BackendUserRole {
  switch (role) {
    case 'admin':
      return 'Admin';
    case 'gerente':
      return 'Manager';
    case 'vendedor':
      return 'Sales';
    case 'whitelabel':
      return 'WhiteLabel';
    default:
      return 'Sales';
  }
}

export function getRoleDisplayName(role: string): string {
  const normalized = (role || '').toLowerCase();
  
  switch (normalized) {
    case 'admin':
      return 'Administrador';
    case 'gerente':
    case 'manager':
      return 'Gerente';
    case 'vendedor':
    case 'sales':
      return 'Vendedor';
    case 'whitelabel':
      return 'White Label';
    default:
      return 'Vendedor'; // Default fallback
  }
}

export function isSalesRole(role: string): boolean {
  const normalized = (role || '').toLowerCase();
  return normalized === 'sales' || normalized === 'vendedor';
}

export function isAdminRole(role: string): boolean {
  const normalized = (role || '').toLowerCase();
  return normalized === 'admin';
}

export function isManagerRole(role: string): boolean {
  const normalized = (role || '').toLowerCase();
  return normalized === 'manager' || normalized === 'gerente';
}

export function isWhiteLabelRole(role: string): boolean {
  const normalized = (role || '').toLowerCase();
  return normalized === 'whitelabel';
}

export function isAdminLike(role: string): boolean {
  return isAdminRole(role) || isWhiteLabelRole(role);
}